<div class="compliance-wrapper">
	<div class="compliance-container">
		<div class="compliance-container-inner">
			<img
				class="d-none d-md-block orange-pattern-overlay"
				src="../../assets/img/orange-pattern.png"
				alt=""
			/>
			<div class="container text-center">
				<div class="row">
					<div class="col-md-4 mb-5 mb-lg-0">
						<img
							class="challenges-list-img"
							src="../../assets/img/our-hq.svg"
							alt=""
						/>
						<div class="challenges-list-head">
							Find us at our HQ
						</div>
						<div class="challenges-list-content">
							RegScale, Inc.<br class="d-none d-xl-block" />
							1775 Tysons Boulevard, Fifth Floor<br
								class="d-none d-xl-block"
							/>
							Tysons, VA 22102
						</div>
					</div>
					<div class="col-md-4 mb-5 mb-lg-0">
						<img
							class="challenges-list-img"
							src="../../assets/img/our-hq.svg"
							alt=""
						/>
						<div class="challenges-list-head">
							Find us at our R&D Office
						</div>
						<div class="challenges-list-content">
							RegScale, Inc.<br class="d-none d-xl-block" />
							2704 Cherokee Farm Way, Suite 204<br
								class="d-none d-xl-block"
							/>
							Knoxville, TN 37920
						</div>
					</div>
					<div class="col-md-4 mb-5 mb-lg-0">
						<img
							class="challenges-list-img"
							src="../../assets/img/ring.svg"
							alt=""
						/>
						<div class="challenges-list-head">Give us a ring</div>
						<div class="challenges-list-content">
							RegScale Sales <br class="d-none d-xl-block" />
							202-991-7881 <br class="d-none d-xl-block" />
							Mon - Fri, 8:00 AM - 5:00 PM ET
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</div>
